import { createFileRoute, redirect } from "@tanstack/react-router";
import { meQueryOptions } from "@/features/auth/api/auth.queries";
import { LoginPage } from "@/features/auth/LoginPage";

export const Route = createFileRoute("/login")({
  beforeLoad: async ({ context }) => {
    try {
      await context.queryClient.fetchQuery(meQueryOptions);
    } catch {
      // 401 or backend unreachable — render the login form.
      return;
    }
    // redirect() throws — must sit outside the try/catch or the catch swallows it.
    throw redirect({ to: "/" });
  },
  component: LoginPage,
});
